import { render, staticRenderFns } from "./SearchCoinNew.vue?vue&type=template&id=277de52e&"
import script from "./SearchCoinNew.vue?vue&type=script&lang=js&"
export * from "./SearchCoinNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports